import { Navigate, useLocation } from "react-router-dom"
import { useAuth } from "hooks/authHook"

const SelfProfile = () => {
  const { user, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return null
  }

  const identifier = user?.username || user?.id

  if (!identifier) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  }

  return (
    <Navigate
      to={`/user-list/${identifier}/view`}
      replace
      state={{ from: location }}
    />
  )
}

export default SelfProfile
